import React, { type ReactNode } from 'react';
import ModalContainer from '../globals/ModalContainer';
import styled from 'styled-components';
import { Button, CircularProgress } from '@mui/material';

interface Props {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  deleting: boolean;
  setDeleting: React.Dispatch<React.SetStateAction<boolean>>;
  confirmDeleteCampaign: () => Promise<void>;
}

interface CustomButtonI {
  withBackground: boolean;
}

interface CustomButtonTextI {
  white: boolean;
  children?: ReactNode
}

export default function MoreInfoModal({
  isVisible,
  setIsVisible,
  deleting,
  setDeleting,
  confirmDeleteCampaign,
}: Props): JSX.Element {
  const handleClose = (): void => {
    setIsVisible(false);
  };

  return (
    <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible}>
      <Container>
        <Title>Hubo un error inesperado</Title>
        <Message>
          Esta campaña está presentando un error al enviar la notificación, te recomendamos
          eliminarla y crear una nueva.
        </Message>
        <ButtonsContainer>
          <CustomButton disabled={deleting} onClick={handleClose} withBackground={false}>
            <ButtonText white={false}>Cancelar</ButtonText>
          </CustomButton>
          <CustomButton disabled={deleting} onClick={confirmDeleteCampaign} withBackground={true}>
            {deleting ? (
              <CircularProgress size={22} style={{ color: 'white' }} />
            ) : (
              <ButtonText white={true}>Eliminar campaña</ButtonText>
            )}
          </CustomButton>
        </ButtonsContainer>
      </Container>
    </ModalContainer>
  );
}

const Container = styled.div``;

const Title = styled.p`
  font-family: ${(props) => props.theme.fonts.semiBold};
  color: ${(props) => props.theme.colors.primary};
  font-size: 20px;
  margin-bottom: 15px;
`;

const Message = styled.p`
  font-family: ${(props) => props.theme.fonts.regular};
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 20px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
  @media screen and (max-width: 660px) {
    flex-direction: column-reverse;
  }
`;

const CustomButton = styled(Button)<CustomButtonI>`
  &&& {
    border: 1px solid;
    border-color: ${(props) =>
      props?.withBackground ? 'transparent' : props.theme.colors.primary};
    border-radius: 20px;
    background-color: ${(props) => (props?.withBackground ? '#F3264B' : 'transparent')};
    @media screen and (max-width: 660px) {
      width: 100%;
    }
  }
`;

const ButtonText = styled.p<CustomButtonTextI>`
  text-transform: none;
  font-family: ${(props) => props.theme.fonts.medium};
  color: ${(props) => (props.white ? 'white' : props.theme.colors.primary)};
  font-size: 13px;
  padding: 0px 15px;
`;
